import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedCountry: {
    id: "",
    name: "",
    corridorId: "",
    iconUrl: "",
  },
  selectedCurrency: {
    id: "",
    name: "",
    symbol: "",
  },
  activeButton: {
    name: "Transfers",
    retryData: null,
    retrySource: null,
  },
  amount: "",
  transferTypeID: "",
  selectedMethod: {},
  fields: [],
  preserveInputs: false,
};

const transferCountrySelection = createSlice({
  name: "transferCountrySelection",
  initialState,

  reducers: {
    setSelectedCountry: (state, action) => {
      state.selectedCountry = action.payload;
    },
    setSelectedCurrency: (state, action) => {
      state.selectedCurrency = action.payload;
    },
    setSelectedActionButton: (state, action) => {
      state.activeButton = action.payload;
    },
    setAmount: (state, action) => {
      state.amount = action.payload;
    },
    setTransferTypeID: (state, action) => {
      state.transferTypeID = action.payload;
    },
    setSelectedMethod: (state, action) => {
      state.selectedMethod = action.payload;
    },
    setInternationalTransferFields: (state, action) => {
      state.fields = action.payload;
    },
    setPreserveInputs: (state, action) => {
      state.preserveInputs = action.payload;
    },
    resetSelections: (state) => {
      state.selectedCountry = initialState.selectedCountry;
      state.selectedCurrency = initialState.selectedCurrency;
      state.amount = initialState.amount;
      state.transferTypeID = initialState.transferTypeID;
    },
  },
});

export const {
  setSelectedCountry,
  setSelectedCurrency,
  setAmount,
  setSelectedActionButton,
  setTransferTypeID,
  setSelectedMethod,
  setInternationalTransferFields,
  setPreserveInputs,
  resetSelections,
} = transferCountrySelection.actions;

export default transferCountrySelection.reducer;
